import React from "react"
import ModalComponent from "../../../CQIPage/components/ModalComponent"
import intl from "react-intl-universal"
import styles from "./index.module.scss"
import { I13s } from "../../../../../assets/icons/sigma/I13s"
import { I6x } from "../../../../../assets/icons/sigma/I6x"
import { I8x } from "../../../../../assets/icons/sigma/I8x"
import { I41s } from "../../../../../assets/icons/sigma/I41s"
import { IR4s } from "../../../../../assets/icons/sigma/IR4s"
import { Flex } from "@stardust-ds/react"

export const ModalTableReference = ({ setBOpenModalTableReference }) => {
  const dataTableReference = [
    {
      below: intl.get("sigma.table_reference.below_2"),
      rule: <I6x />,
      n: 6,
    },
    {
      below: intl.get("sigma.table_reference.between_2_and_3"),
      rule: <I6x />,
      n: 6,
    },
    {
      below: intl.get("sigma.table_reference.between_3_and_4"),
      rule: <I8x />,
      n: 4,
    },
    {
      below: intl.get("sigma.table_reference.between_4_and_5"),
      rule: <I41s />,
      n: 4,
    },
    {
      below: intl.get("sigma.table_reference.between_5_and_6"),
      rule: <IR4s />,
      n: 2,
    },
    {
      below: intl.get("sigma.table_reference.above_of_6"),
      rule: <I13s />,
      n: 2,
    },
  ]

  const fnCloseModal = () => {
    setBOpenModalTableReference(false)
  }

  return (
    <ModalComponent
      title={intl.get("sigma.btn_table_reference")}
      fnCloseModal={fnCloseModal}
      size={"lg"}
    >
      <table className={styles.table}>
        <thead className={styles.head}>
          <tr>
            <th>{intl.get("sigma.table_reference.sigma_metric")}</th>
            <th>{intl.get("sigma.rule_decision")}</th>
            <th>
              <Flex className={styles.columnAlert}>
                N<span>*</span>
              </Flex>
            </th>
          </tr>
        </thead>
        <tbody className={styles.body}>
          {dataTableReference.map((item, index) => {
            return (
              <tr
                key={index}
                style={{
                  cursor: "normal !important",
                }}
              >
                <td className={`${styles.td}`}>{item.below}</td>
                <td className={`${styles.td}`}>{item.rule}</td>
                <td className={`${styles.td}`}>{item.n}</td>
              </tr>
            )
          })}
        </tbody>
      </table>
      <p className={styles.warningText}>
        {intl.get("sigma.table_reference.n_column_description")}
      </p>
    </ModalComponent>
  )
}
